import {
  CalendarRegular,
  LocationRegular,
  MapRegular,
} from '@fluentui/react-icons';
import { tokens } from '@fluentui/react-components';
import type { ISlotEntryData } from '@moko/utils';

export const ICON_MAP: Record<string, React.FC<{ fontSize?: number }>> = {
  CalendarRegular,
  LocationRegular,
  MapRegular,
};

export const formatEntryText = (entry: ISlotEntryData): string =>
  entry.value ?? '';

export const FieldIcon = ({
  icon,
  fontSize,
  fontWeight,
}: {
  icon?: string;
  fontSize: string;
  fontWeight?: string;
}) => {
  if (!icon) return null;
  const IconComp = ICON_MAP[icon];
  if (!IconComp) return null;
  const textSize = parseInt(fontSize, 10) || 16;
  const size = Math.round(textSize * 1.2);
  const weight = parseInt(fontWeight ?? '400', 10);
  const opacity = weight >= 600 ? 0.9 : 0.6;
  return (
    <span
      style={{
        display: 'flex',
        alignItems: 'flex-start',
        marginTop: 1,
        opacity,
        color: tokens.colorBrandForeground1,
      }}
    >
      <IconComp fontSize={size} />
    </span>
  );
};
